import React from "react";
import Header from "../components/layout/Header";
import Hero from "../components/route/Hero";
import Categories from "../components/route/Categories";
import BestDeals from "../components/route/BestDeals";
import Footer from "../components/layout/Footer";
import FooterBottom from "../components/layout/FooterBottom";

const Home = () => {
  return (
    <>
      <Header activeHeading={1} />
      <div className="w-full mx-auto">
        <Hero />
      </div>
      <Categories />
      <BestDeals />
      <Footer />
      <FooterBottom />
    </>
  );
};

export default Home;
